import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMAGES, WHATSAPP_URL } from "../../lib/constants";

const transformaciones = [
    {
        nombre: "Laura M.",
        meta: "-14 kg • 6 meses",
        quote: "Recuperé mi cuerpo y mi seguridad. Aquí no estás sola.",
        before: IMAGES.transformBefore,
        after: IMAGES.womanGlutes,
    },
    {
        nombre: "Carlos R.",
        meta: "+8 kg músculo • 5 meses",
        quote: "Pasé de no levantar peso a competir. Cambio total.",
        before: IMAGES.manFunctional,
        after: IMAGES.manDeadlift,
    },
    {
        nombre: "Marta G.",
        meta: "-9 kg grasa • 4 meses",
        quote: "Más fuerte que nunca. No vuelvo atrás.",
        before: IMAGES.womanLift2,
        after: IMAGES.womanLift1,
    },
];

export default function Transformaciones() {
    return (
        <section
            id="transformaciones"
            data-testid="transformaciones-section"
            className="relative bg-[#0A0A0A] py-24 md:py-32 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <div className="text-center mb-16">
                    <span className="font-display tracking-[0.4em] text-xs text-brand-orange">
                        // RESULTADOS REALES
                    </span>
                    <h2 className="font-display text-5xl md:text-7xl lg:text-8xl mt-4 leading-[0.9] text-brand-text">
                        TRANSFORMACIONES
                        <br />
                        <span className="orange-text">QUE INSPIRAN.</span>
                    </h2>
                    <p className="mt-6 max-w-2xl mx-auto text-brand-muted">
                        Cada cuerpo cuenta una historia. La constancia y el
                        método F You las reescriben.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-6">
                    {transformaciones.map((t, idx) => (
                        <motion.div
                            key={t.nombre}
                            data-testid={`transform-card-${idx}`}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ delay: idx * 0.15, duration: 0.7 }}
                            className="group relative bg-[#0F0F0F] border border-white/10 overflow-hidden glow-border"
                        >
                            <div className="grid grid-cols-2 h-72 md:h-80">
                                <div className="relative overflow-hidden">
                                    <img
                                        src={t.before}
                                        alt="Antes"
                                        className="w-full h-full object-cover grayscale contrast-110 group-hover:scale-105 transition-transform duration-700"
                                    />
                                    <div className="absolute top-3 left-3 font-display tracking-[0.3em] text-[10px] text-brand-text bg-black/70 px-2 py-1">
                                        ANTES
                                    </div>
                                </div>
                                <div className="relative overflow-hidden">
                                    <img
                                        src={t.after}
                                        alt="Después"
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                    />
                                    <div className="absolute top-3 right-3 font-display tracking-[0.3em] text-[10px] text-black bg-brand-orange px-2 py-1">
                                        DESPUÉS
                                    </div>
                                </div>
                            </div>
                            <div className="p-6">
                                <div className="flex items-center justify-between mb-3">
                                    <div className="font-display text-2xl text-brand-text">
                                        {t.nombre}
                                    </div>
                                    <span className="font-display tracking-widest text-[10px] text-brand-gold">
                                        {t.meta}
                                    </span>
                                </div>
                                <p className="text-sm text-brand-muted italic leading-relaxed">
                                    "{t.quote}"
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>

                <div className="mt-14 text-center">
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="transform-cta"
                        className="inline-flex items-center gap-3 bg-brand-orange hover:bg-brand-orangeHover text-black font-display tracking-wider px-8 py-5 transition-all hover:scale-[1.02]"
                    >
                        EMPIEZA TU TRANSFORMACIÓN
                        <ArrowRight size={18} />
                    </a>
                </div>
            </div>
        </section>
    );
}
